import clsx from "clsx";
import { Link } from "react-router-dom";

export function RecentlyViewedList({
    title = "Recently viewed",
    children,
}: {
    title?: string;
    children: React.ReactNode;
}) {
    return (
        <div className="flex w-full flex-col gap-4">
            <p className="lozenge">{title}</p>
            <ul className="-mx-4 flex flex-col gap-4">{children}</ul>
        </div>
    );
}

export function RecentlyViewedItem({
    href,
    children,
    className,
}: {
    href: string;
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <li className="card w-full">
            <Link
                to={href}
                className={clsx(
                    "flex cursor-pointer items-center gap-4",
                    className,
                )}
            >
                {children}
            </Link>
        </li>
    );
}
